import React from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-scroll";
import { useRoomContext } from "../../context/RoomContext";

interface IRoomDetailsBanner {
  id: number;
}

const RoomDetailsBanner = (props: IRoomDetailsBanner) => {
  const { roomData } = useRoomContext();
  const filterRoomData = roomData.filter((room) => room?.id === props.id);
  return (
    <>
      <div
        id="page_caption"
        className="hasbg"
        style={{
          display: "block",
          backgroundImage: `url(${process.env.REACT_APP_cmsUrl}/uploads/${filterRoomData[0]?.main_image[0]?.media?.name})`,
        }}
      >
        {/* <div id="page_caption_overlay"></div> */}
        <div className="custom-gradient"></div>
        <div className="page_title_wrapper">
          <div className="standard_wrapper">
            <div className="page_title_inner">
              <div className="page_title_content">
                <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                  <h1>{filterRoomData[0]?.room_name}</h1>
                  <div className="post_attribute">
                    {filterRoomData[0]?.attributes?.Banner_Title}
                  </div>
                </Fade>
              </div>
            </div>

            <ul id="page_title_nav" className="page_title_nav">
              <Fade cascade damping={0.2} triggerOnce={true}>
                <li style={{ cursor: "pointer" }}>
                  <Link
                    to="singleroom_detail"
                    smooth={true}
                    duration={500}
                    className="room_detail_link"
                  >
                    Detail
                  </Link>
                </li>
                <li style={{ cursor: "pointer" }}>
                  <Link
                    to="singleroom_amenities"
                    smooth={true}
                    duration={500}
                    className="room_amenties_link"
                  >
                    Amenities &amp; Services
                  </Link>
                </li>
                <li style={{ cursor: "pointer" }}>
                  <Link
                    to="singleroom_gallery"
                    smooth={true}
                    duration={500}
                    className="room_gallery_link"
                  >
                    Gallery
                  </Link>
                </li>
              </Fade>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoomDetailsBanner;
